import { useState, useEffect } from 'react'
import { FiAlertCircle } from 'react-icons/fi'
import {
  Backdrop,
  ModalCard,
  Title,
  Message,
  Countdown,
  UpgradeText,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton,
} from './styles'

export function RateLimitModal({ isOpen, onClose, resetAt }) {
  const [timeRemaining, setTimeRemaining] = useState('')

  useEffect(() => {
    if (!isOpen || !resetAt) return

    const updateCountdown = () => {
      const resetTime = new Date(resetAt)
      const now = new Date()
      const diff = resetTime - now

      if (diff <= 0) {
        setTimeRemaining('em breve')
        return
      }

      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      if (hours > 0) {
        setTimeRemaining(`${hours} hora${hours > 1 ? 's' : ''} e ${minutes} minuto${minutes !== 1 ? 's' : ''}`)
      } else {
        setTimeRemaining(`${minutes} minuto${minutes !== 1 ? 's' : ''}`)
      }
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [isOpen, resetAt])

  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <Backdrop onClick={handleBackdropClick}>
      <ModalCard>
        <Title>
          <FiAlertCircle size={32} />
          Limite Atingido
        </Title>

        <Message>Você atingiu o limite de 3 cálculos por dia do plano gratuito.</Message>

        {timeRemaining && <Countdown>Seu limite redefine em: {timeRemaining}</Countdown>}

        <UpgradeText>✨ Faça upgrade para acesso ilimitado!</UpgradeText>

        <ButtonsContainer>
          <PrimaryButton to="/pricing" onClick={onClose}>
            Ver Planos
          </PrimaryButton>
          <SecondaryButton onClick={onClose}>Fechar</SecondaryButton>
        </ButtonsContainer>
      </ModalCard>
    </Backdrop>
  )
}
